import Vue from "vue";
import LoadPage from "./LoadPage.vue";

let isExit = false;
let queue = [];

const defaultOptions = {
  mode: "loadingHardly"
};

function createInstance(options = defaultOptions) {
  let instance = null;
  if (!queue.length || !isExit) {
    const LoadPageVue = Vue.extend(LoadPage);
    instance = new LoadPageVue({
      el: document.createElement("div"),
      data: {
        mode: options.mode
      }
    });
    document.body.appendChild(instance.$el);
    queue.push(instance);
  }
  return queue[queue.length - 1];
}

function LPage(options) {
  const instance = createInstance(options);
  options = {
    ...defaultOptions,
    ...options,
    clear() {
      if (!isExit) {
        queue = queue.filter(item => item !== instance);
        document.body.removeChild(instance.$el);
        instance.$destroy();
      }
    }
  };
  Object.assign(instance, options);
  return instance;
}

LPage.clear = () => {
  if (queue.length) {
    queue.forEach(popup => {
      popup.clear();
    });
    queue = [];
  }
};

LPage.install = Vue => {
  Vue.prototype.$loadPage = LPage;
};

export default LPage;
